// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_qy-5";
export var filledCircle = "_qy-4";
export var historyEntry = "_qy-3";
export var messageSideLeft = "_qy-1";
export var messageSideRight = "_qy-2";
export var orderTrackingCarouselWrapper = "_qy-6";
export var orderTrackingInfoContainer = "_qy-0";